export const base_url = "https://aldahayan.net";
// export const base_url = "https://localhost:7022";
export const paymentPeriodOptions = [
  {
    value: 6,
    label: 6,
  },
  {
    value: 12,
    label: 12,
  },
  {
    value: 18,
    label: 18,
  },
  {
    value: 24,
    label: 24,
  },
  {
    value: 30,
    label: 30,
  },
  {
    value: 36,
    label: 36,
  },
  {
    value: 48,
    label: 48,
  },
  {
    value: 60,
    label: 60,
  },
];

export const paid_MoneyOptions = [
  {
    value: 0,
    label: 0,
  },
  {
    value: 10,
    label: 10,
  },
  {
    value: 15,
    label: 15,
  },
  {
    value: 20,
    label: 20,
  },
  {
    value: 25,
    label: 25,
  },
  {
    value: 30,
    label: 30,
  },
  {
    value: 35,
    label: 35,
  },
  {
    value: 40,
    label: 40,
  },
  {
    value: 45,
    label: 45,
  },
  {
    value: 50,
    label: 50,
  }
];